var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('quick-actions'),_c('sales-summary'),_c('cash-summary'),_c('sales-history')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }